import Avatar1 from "./images/users/avatar-1.jpg";
import profileImage from "./images/users/avatar-1.jpg";
import logoSm from "./images/xcruit-logo.svg";
import logoDark from "./images/xcruit-logo.svg";
import logoIcon from "./images/xcruit-logo.ico";
import errorImagesvg from "./images/error.svg";
import defaultprofile from "./images/profile-img-default.png";
import playButton from "./images/play-button.png";
import blankProfile from "./images/blank-profile.webp";
import SigninPageBack from "./images/login-banner.png";
import DefultImage from "./images/DefultImage.png";
import Excel from "./images/excel.png";
import loginPeople from "./images/login-people.png";
const allImages = {
  Excel,
  blankProfile,
  playButton,
  defaultprofile,
  errorImagesvg,
  Avatar1,
  profileImage,
  logoSm,
  logoDark,
  SigninPageBack,
  DefultImage,
  logoIcon,
  loginPeople,
};

export default allImages;
